import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M7 21h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 3v18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Scale";
const Scale = memo(themed(Icon));
export {
  Scale
};
//# sourceMappingURL=scale.js.map
